import React from "react";
import {FormattedMessage} from "react-intl";
import classes from "./styles.module.css";

function AntiFraudDetails({record, reference, onUnblock, onDelete}) {
    if (!record) return null;

    const sourceItem = (reference.sources || []).find((s) => s.value === record.source);
    const kindItem = (reference.kinds || []).find((k) => k.value === record.kind);

    const formatDate = (dateStr) => {
        if (!dateStr) return "—";
        const d = new Date(dateStr);
        return d.toLocaleDateString("ru-RU") + " " + d.toLocaleTimeString("ru-RU");
    };

    return (
        <div className={classes.Card}>
            <div className={classes.Header}>
                <h5 className={classes.Title}>
                    <FormattedMessage id="AntiFraudDetails.title" defaultMessage="Детали записи"/>
                    <span className={classes.RecordId}>#{record.id}</span>
                </h5>
            </div>

            <div className={classes.Body}>
                <div className={classes.Row}>
                    <span className={classes.Label}>Источник:</span>
                    <span className={classes.Value}>{(sourceItem && sourceItem.label) || record.source}</span>
                </div>

                <div className={classes.Row}>
                    <span className={classes.Label}>Тип:</span>
                    <span className={classes.Value}>{(kindItem && kindItem.label) || record.kind}</span>
                </div>

                <div className={classes.Row}>
                    <span className={classes.Label}>Значение (маска):</span>
                    <span className={classes.ValueMono}>{record.valueMasked || "—"}</span>
                </div>

                <div className={classes.Row}>
                    <span className={classes.Label}>Статус:</span>
                    <span className={record.isBlocked ? classes.StatusBlocked : classes.StatusOk}>
                        {record.isBlocked ? "Заблокирован" : "Разблокирован"}
                    </span>
                </div>

                <div className={classes.Row}>
                    <span className={classes.Label}>Код причины:</span>
                    <span className={classes.Value}>{record.reasonCode || "—"}</span>
                </div>

                <div className={classes.Row}>
                    <span className={classes.Label}>Сообщение:</span>
                    <span className={classes.Value}>{record.reasonMessage || "—"}</span>
                </div>

                <div className={classes.Row}>
                    <span className={classes.Label}>Попадания:</span>
                    <span className={classes.Value}>{record.hits || 0}</span>
                </div>

                <div className={classes.Row}>
                    <span className={classes.Label}>Срок действия:</span>
                    <span className={classes.Value}>
                        {record.expiresAt ? formatDate(record.expiresAt) : "Бессрочно"}
                    </span>
                </div>

                <div className={classes.Row}>
                    <span className={classes.Label}>Первое попадание:</span>
                    <span className={classes.Value}>{formatDate(record.firstSeenAt)}</span>
                </div>

                <div className={classes.Row}>
                    <span className={classes.Label}>Последнее попадание:</span>
                    <span className={classes.Value}>{formatDate(record.lastSeenAt)}</span>
                </div>

                <div className={classes.Row}>
                    <span className={classes.Label}>Создано:</span>
                    <span className={classes.Value}>{record.createdBy || "—"}</span>
                </div>

                {record.meta && Object.keys(record.meta).length > 0 && (
                    <div className={classes.MetaSection}>
                        <span className={classes.Label}>Метаданные:</span>
                        <pre className={classes.Meta}>
                            {JSON.stringify(record.meta, null, 2)}
                        </pre>
                    </div>
                )}
            </div>

            <div className={classes.Actions}>
                {record.isBlocked && (
                    <button
                        className={classes.UnblockBtn}
                        onClick={() => onUnblock(record.id)}
                    >
                        <FormattedMessage id="AntiFraudDetails.unblock" defaultMessage="Разблокировать"/>
                    </button>
                )}
                <button
                    className={classes.DeleteBtn}
                    onClick={() => onDelete(record.id)}
                >
                    <FormattedMessage id="AntiFraudDetails.delete" defaultMessage="Удалить"/>
                </button>
            </div>
        </div>
    );
}

AntiFraudDetails.defaultProps = {
    reference: {sources: [], kinds: []},
    onUnblock: () => {
    },
    onDelete: () => {
    },
};

export default AntiFraudDetails;



// WEBPACK FOOTER //
// ./src/Components/ComponentsOfAdministrator/AntiFraudDetails/index.js